import { AccessGrantMatcher } from './IAccessGrant';

const matchByEntityIds = (contextKey: string, ids: string[]): AccessGrantMatcher => {
  const set = new Set(ids);

  return (context) => {
    const entityIds = context[contextKey] as string[] | undefined;

    return entityIds?.some((id) => set.has(id)) ?? false;
  };
};

export const matchByMarket = (...marketIds: string[]): AccessGrantMatcher =>
  matchByEntityIds('marketIds', marketIds);

export const matchByRegion = (...regionIds: string[]): AccessGrantMatcher =>
  matchByEntityIds('regionIds', regionIds);

export const matchByDealMarket = (...marketIds: string[]): AccessGrantMatcher =>
  matchByEntityIds('dealMarketIds', marketIds);

export const matchByProduct = (...productIds: string[]): AccessGrantMatcher =>
  matchByEntityIds('productIds', productIds);

export const matchByPath = (...patterns: RegExp[]): AccessGrantMatcher => {
  return (context) => {
    const pathname = context.pathname as string | undefined;

    return pathname ? patterns.some((pattern) => pattern.test(pathname)) : false;
  };
};

export const anyOf = (...matchers: AccessGrantMatcher[]): AccessGrantMatcher => {
  return (context) => matchers.some((matcher) => matcher(context));
};

export const allOf = (...matchers: AccessGrantMatcher[]): AccessGrantMatcher => {
  return (context) => matchers.every((matcher) => matcher(context));
};

export const not = (matcher: AccessGrantMatcher): AccessGrantMatcher => {
  return (context) => !matcher(context);
};
